import Vue from 'vue';
import VCalendar from 'v-calendar';
import PinchZoom from "vue-pinch-zoom"
import VueResize from 'vue-resize'

Vue.use(VCalendar);
Vue.use(VueResize)
Vue.component('PinchZoom', PinchZoom);
